import { inject, Injectable, WritableSignal } from '@angular/core';
import { WebSocketService } from '@services/web-socket.service';
import { AuthService } from '@services/auth.service';
import { TopicType } from '../enums/topic-type';
import { RoomLocationStore } from '@stores/room-location.store';
import { LocatingSpace } from '@interfaces/location/locating-space';
import { LocationDataPayload } from '@interfaces/location/location-data-response';
import { RoomLocation } from '@interfaces/location/room-location';

@Injectable({
  providedIn: 'root',
})
export class RoomLocationService {
  private webSocketService = inject(WebSocketService);
  private authService = inject(AuthService);
  private roomLocationStore = inject(RoomLocationStore);

  generalLocations = this.roomLocationStore.generalLocations as WritableSignal<
    RoomLocation[]
  >;
  locatingSpaces = this.roomLocationStore.locatingSpaces as WritableSignal<
    LocatingSpace[]
  >;

  sendLocationDataRequest() {
    const userId = this.authService.user().id;
    const message: object = {
      requester: userId,
    };

    this.webSocketService.send({
      topic: TopicType.LOCATION_DATA_REQUEST,
      message,
    });
  }

  setLocations(locations: LocationDataPayload) {
    this.roomLocationStore.setLocations(locations);
  }
}
